export const handleCustomFieldUpdate = (contact, event) => {
  const { custom_field_value } = event;
  const existingFieldIndex = contact.customFields.findIndex(
    f => f.custom_field_id === custom_field_value.custom_field_id
  );

  if (existingFieldIndex >= 0) {
    contact.customFields[existingFieldIndex] = {
      ...contact.customFields[existingFieldIndex],
      value: custom_field_value.value,
    };
  } else {
    contact.customFields.push({
      custom_field_id: custom_field_value.custom_field_id,
      value: custom_field_value.value,
    });
  }
};
